import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './NameDrawer.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'
import { parseSpreadsheetNames } from './utils/spreadsheetImport'

const shuffle = (list) => {
  const copy = [...list]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
      ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy
}

const NameDrawer = () => {
  useDocumentMeta({
    title: 'Sorteador de Nomes Online  Amigo Secreto e Rifas',
    description:
      'Sorteie nomes para amigo secreto, rifas e sorteios em geral. Cole ' +
      'a lista ou importe uma planilha  grátis, sem cadastro, direto no ' +
      'navegador.',
  })

  const [namesText, setNamesText] = useState('')
  const [winnerCount, setWinnerCount] = useState('1')
  const [winners, setWinners] = useState([])
  const [error, setError] = useState('')
  const fileInputRef = useRef(null)

  const names = namesText
    .split('\n')
    .map((n) => n.trim())
    .filter(Boolean)

  const draw = () => {
    if (names.length < 2) {
      setError('Coloque pelo menos 2 nomes, um por linha.')
      setWinners([])
      return
    }
    setError('')
    const count = Math.max(
      1,
      Math.min(Number.parseInt(winnerCount, 10) || 1, names.length),
    )
    setWinners(shuffle(names).slice(0, count))
    trackEvent('tool_generate', {
      tool: 'name_drawer',
      names_count: names.length,
      winners_count: count,
    })
  }

  const handleFileImport = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => {
      const imported = parseSpreadsheetNames(String(reader.result))
      setNamesText((current) =>
        current ? `${current}\n${imported.join('\n')}` : imported.join('\n'),
      )
      setError('')
      trackEvent('tool_import', {
        tool: 'name_drawer',
        names_count: imported.length,
      })
    }
    reader.readAsText(file)
    event.target.value = ''
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Sorteio de Nomes</h1>
      <p className="tool-disclaimer">
        Cole uma lista de nomes (um por linha) ou importe uma planilha
        ótimo para amigo secreto, rifas e sorteios em geral.
      </p>

      <div className="tool-field">
        <label htmlFor="names">Nomes (um por linha)</label>
        <textarea
          id="names"
          rows="8"
          value={namesText}
          onChange={(e) => setNamesText(e.target.value)}
          placeholder={'Maria\nJoão\nAna\nPedro'}
        />
      </div>

      <div className="tool-import-row">
        <button
          type="button"
          className="tool-button tool-button-secondary"
          onClick={() => fileInputRef.current.click()}
        >
          <span role="img" aria-label="arquivo">
            📄
          </span>{' '}
          Importar planilha (.csv/.txt)
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.txt"
          onChange={handleFileImport}
          hidden
        />
        <span className="tool-import-hint">
          Salve sua planilha do Excel/Google Sheets como CSV antes de
          importar.
        </span>
      </div>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="winnerCount">Quantos sortear</label>
          <input
            id="winnerCount"
            type="number"
            min="1"
            value={winnerCount}
            onChange={(e) => setWinnerCount(e.target.value)}
          />
        </div>
      </div>

      <button type="button" className="tool-button" onClick={draw}>
        Sortear
      </button>

      {error && <p className="name-drawer-error">{error}</p>}

      {winners.length > 0 && (
        <div className="tool-result-card name-drawer-result">
          <span className="tool-result-label">
            {winners.length > 1 ? 'Sorteados' : 'Sorteado'}
          </span>
          <ul className="name-drawer-list">
            {winners.map((name, i) => (
              <li key={`${name}-${i}`}>{name}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Como funciona o sorteio</h2>
        <p>
          A lista é embaralhada localmente no seu navegador (algoritmo de
          Fisher-Yates, que garante que cada ordem possível tem a mesma
          chance) e os primeiros nomes do resultado são os sorteados.
          Nada é enviado a um servidor  tanto a lista quanto o resultado
          ficam só na sua máquina. Funciona bem para amigo secreto,
          sorteio de brindes, definir quem começa um jogo ou distribuir
          tarefas em equipe.
        </p>
      </div>
    </div>
  )
}

export default NameDrawer
